import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

import type { FindingSeverity } from "./Finding";

// Подпись оценки для экранных дикторов и плиток «светофора».
export const SEVERITY_LABELS: Record<FindingSeverity, MessageDescriptor> = {
  good: msg({ id: "analysis.severity.good", message: "Fine" }),
  warn: msg({ id: "analysis.severity.warn", message: "Worth improving" }),
  bad: msg({ id: "analysis.severity.bad", message: "Serious mistake" }),
};
